import { FC } from 'react';
import { ICheckInData } from 'mod/checkIn/interface';
import styles from './index.module.less';
import { Trans } from 'base/utils/i18n';

type IEarnedTipProps = {
    data: ICheckInData;
};

export const EarnedTip: FC<IEarnedTipProps> = props => {
    const { data: { shareBoom: { points } } } = props;

    return (
        <div className={styles['earned-tip']}>
            <Trans
                i18nKey={'web_checkin_earned_points'}
                components={{ Num: <span className={'text-primary'}>{points}</span> }}
            />
        </div>
    )
};
